import { useOrderContactInfo } from 'checkout/hooks';
import React from 'react';
import { isValidContactInfo } from 'utilities/validators';
import './UpdateSenderInformation.scss';
export function UpdateSenderInformation({ setShouldDisableCheckout }) {
    const orderContactInfo = useOrderContactInfo();
    const contactInfoValid = isValidContactInfo(orderContactInfo);
    const forceB2BCheckoutDisabled = false;
    setShouldDisableCheckout(!contactInfoValid.valid || forceB2BCheckoutDisabled);
    return (React.createElement("div", { className: 'update-sender-information' },
        !contactInfoValid.valid && React.createElement("div", { className: 'update-sender-information__error' }, "Du m\u00E5 oppdatere avsenderinformasjon f\u00F8r du kan gjennomf\u00F8re kj\u00F8pet."),
        forceB2BCheckoutDisabled && React.createElement("div", { className: 'update-sender-information__error' }, "Grunnet tekniske problemer med faktural\u00F8sningen er bestilling midlertidig utilgjengelig. Vi jobber med en l\u00F8sning og forventer \u00E5 v\u00E6re i drift i l\u00F8pet av dagen. Ved hastesaker, kontakt B2B avdelingen v\u00E5r p\u00E5 99772427.")));
}
